module.exports = __webpack_public_path__ + "media/icon/arrow-down-9ad903f7.svg";